import { useI18n } from "../i18n/index.tsx"
import type { ColumnChoice } from "../lib/column-prefs.ts"
import { Button, Menu } from "../ui/index.ts"

/**
 * 표에 어떤 칸을 보여 줄지 고르는 판.
 *
 * 무엇을 켤 수 있는지(그리고 마지막 한 칸은 끌 수 없다는 규칙)는
 * `lib/column-prefs.ts` 가 정한다 — 여기서는 고르게만 한다.
 */
export function ColumnPicker({
  columns,
  visible,
  onToggle,
  onReset,
}: {
  columns: readonly ColumnChoice[]
  visible: readonly string[]
  onToggle: (key: string) => void
  onReset: () => void
}) {
  const { t } = useI18n()

  return (
    <Menu label={t("columns.title")} icon="list">
      <div className="picker">
        {columns.map((column) => (
          <label className="picker__row" key={column.key}>
            <input
              type="checkbox"
              checked={visible.includes(column.key)}
              onChange={() => onToggle(column.key)}
            />
            <span>{column.label}</span>
          </label>
        ))}
      </div>
      <Button size="sm" onClick={onReset}>
        {t("columns.reset")}
      </Button>
    </Menu>
  )
}
